import { TBCTXKeysWithoutSize, TCartonMetadata, TFilterPackingType } from '@monorepo/types';

export const PACKING_COMPUTATION_HELPER = {
  getKeyFromFilterType: (filterType: TFilterPackingType) => {
    switch (filterType) {
      case 'BUYER':
        return 'buyer';
      case 'PO':
        return 'po';
      case 'ORDER_REF':
        return 'order_ref';
      case 'STYLE':
        return 'style';
      case 'PRODUCT_TYPE':
        return 'product_type';
      case 'PRODUCT_CATEGORY':
        return 'product_category';
      case 'COLOR':
        return 'color';
      case 'SIZE':
        return 'size';
      default:
        return filterType;
    }
  },
  getFilterTypeFromKey(key: TBCTXKeysWithoutSize) {
    switch (key) {
      case 'buyer':
        return 'BUYER';
      case 'po':
        return 'PO';
      case 'style':
        return 'STYLE';
      case 'order_ref':
        return 'ORDER_REF';
      case 'product_type':
        return 'PRODUCT_TYPE';
      case 'product_category':
        return 'PRODUCT_CATEGORY';
      case 'color':
        return 'COLOR';
      default:
        return '--';
    }
  },
  getHeaderCellDisplayNameFromFilterType: (filterType: TFilterPackingType) => {
    switch (filterType) {
      case 'BUYER':
        return 'packing_common_table_headers.BUYER';
      case 'PO':
        return 'packing_common_table_headers.PO';
      case 'ORDER_REF':
        return 'packing_common_table_headers.ERP_KEY';
      case 'STYLE':
        return 'packing_common_table_headers.STYLE';
      case 'PRODUCT_TYPE':
        return 'packing_common_table_headers.PRODUCT_TYPE';
      case 'PRODUCT_CATEGORY':
        return 'packing_common_table_headers.PRODUCT_CATEGORY';
      case 'COLOR':
        return 'packing_common_table_headers.COLOR';
      case 'SIZE':
        return 'packing_common_table_headers.SIZE';
      case 'PRE_PACK':
        return 'packing_common_table_headers.PRE_PACK';
      default:
        return filterType;
    }
  },
  getDisplayNameFromBctxKey: (key: string, isUpperCase: boolean = false) => {
    switch (key) {
      case 'buyer':
        return isUpperCase ? 'BUYER' : 'Buyer';
      case 'po':
        return isUpperCase ? 'PO' : 'PO';
      case 'order_ref':
        return isUpperCase ? 'ERP KEY' : 'ERP Key';
      case 'style':
        return isUpperCase ? 'STYLE' : 'Style';
      case 'product_type':
        return isUpperCase ? 'PRODUCT TYPE' : 'Product Type';
      case 'product_category':
        return isUpperCase ? 'PRODUCT CATEGORY' : 'Product Category';
      case 'color':
        return isUpperCase ? 'COLOR' : 'Color';
      case 'size':
        return isUpperCase ? 'SIZE' : 'Size';
      case 'packing_method':
        return isUpperCase ? 'PACKING METHOD' : 'Packing Method';
      case 'deliveryDate':
        return isUpperCase ? 'DELIVERY DATE' : 'Delivery Date';
      default:
        return key;
    }
  },
  getDisplaylangJsonKeyFromBctxKey: (key: string, isUpperCase: boolean = false) => {
    switch (key) {
      case 'buyer':
        return isUpperCase ? 'packing_common_table_headers.BUYER' : 'packing_common_table_headers.Buyer';
      case 'po':
        return isUpperCase ? 'packing_common_table_headers.PO' : 'packing_common_table_headers.PO';
      case 'order_ref':
        return isUpperCase ? 'packing_common_table_headers.ERP_KEY' : 'packing_common_table_headers.ERP_Key';
      case 'style':
        return isUpperCase ? 'packing_common_table_headers.STYLE' : 'packing_common_table_headers.Style';
      case 'product_type':
        return isUpperCase ? 'packing_common_table_headers.PRODUCT_TYPE' : 'packing_common_table_headers.Product_Type';
      case 'product_category':
        return isUpperCase
          ? 'packing_common_table_headers.PRODUCT_CATEGORY'
          : 'packing_common_table_headers.Product_Category';
      case 'color':
        return isUpperCase ? 'packing_common_table_headers.COLOR' : 'packing_common_table_headers.Color';
      case 'size':
        return isUpperCase ? 'packing_common_table_headers.SIZE' : 'packing_common_table_headers.Size';
      case 'packing_method':
        return isUpperCase
          ? 'packing_common_table_headers.PACKING_METHOD'
          : 'packing_common_table_headers.Packing_Method';
      case 'deliveryDate':
        return isUpperCase
          ? 'packing_common_table_headers.DELIVERY_DATE'
          : 'packing_common_table_headers.Delivery_Date';
      default:
        return key;
    }
  },

  getCartonBctxItmeValue(cartonMetaData: TCartonMetadata, key: string) {
    switch (key) {
      case 'buyer':
        return cartonMetaData.buyer;
      case 'po':
        return cartonMetaData.po;
      case 'style':
        return cartonMetaData.style;
      case 'order_ref':
        return cartonMetaData.order_ref;
      case 'product_type':
        return cartonMetaData.product_type;
      case 'product_category':
        return cartonMetaData.product_category;
      case 'color':
        return cartonMetaData.color;
      default:
        return '';
    }
  },
};
